import { useAuth } from "@bcmi-labs/art-auth"
import type { ComponentProps } from "react"

import { Loader } from "@/components/ui/Loader"

import styles from "./index.module.scss"

/**
 * A page-sized, centered {@link Loader} (a spinner in customized spaces and under custom palettes).
 *
 * If no `variant` is provided, the loader will be rendered with these default styles:
 * - While the user isn't authenticated and the main store is loading, the loader will be rendered with the `primary` variant.
 * - Otherwise, the loader will be rendered with the `secondary` variant.
 */
export function PageLoader(props: ComponentProps<typeof Loader>) {
  const { variant, ...rest } = props
  const { isAuthenticated } = useAuth()

  return (
    <div className={styles.PageLoader} style={{ height: "100%" }}>
      <Loader variant={variant || (!isAuthenticated ? "primary" : "secondary")} {...rest} />
    </div>
  )
}
